import React, {useState} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import AppointmentCalendarForm from './AppointmentCalendarForm';
import AppointmentInformation from './AppointmentInformation';
import AppointmentLocationForm from './AppointmentLocationForm';
import ContactForm from './ContactForm';
import { ContactMeScreens as Screens } from '../../state/index';

//TODO: clean this up and use Formsy
function ContactMe(props) {
  const {
    bookAppointment,
    onComplete,
    backButton,
    loadingIcon,
    shouldValidateOnBlur,
    shouldValidateOnChange,
    useAppointmentFlow,
    isProcessing,
    validators,

    contactLead,
    onContactFormSubmit,

    getLocations,
    setLocation,
    availableLocations,
    selectedLocation,
    onLocationSearchChange,
    locationSearchForm,

    getTimeSlots,
    setTimeSlot,
    availableTimeSlots,
    selectedTime,
    ...rest
  } = props;
  const [currentScreen, changeScreen] = useState(Screens.CONTACT_FORM);

  let FrameComponent = null;
  let showBackBtn = false;

  const backBtnClicked = () => {
    let nextScreen = false;
    switch (currentScreen) {
      case Screens.APPT_CALENDAR:
        nextScreen = Screens.APPT_LOCATION;
        break;
      case Screens.APPT_LOCATION:
        nextScreen = Screens.CONTACT_FORM;
        break;
      case Screens.APPT_FAIL:
        nextScreen = Screens.CONTACT_FORM;
        break;
      default:
        break;
    }
    if (nextScreen) {
      changeScreen(nextScreen);
    }
  };

  const backButtonRender = (
    <button className="contactMe__backBtn" onClick={backBtnClicked}>
      {backButton || <span>←</span>}
    </button>
  );

  const loadingIconRender = (
    <div className="contactMe__loadingIcon" onClick={backBtnClicked}>
      {loadingIcon || <span className="spinning">◌</span>}
    </div>
  );

  const classes = classnames('contactMe', `contactMe--${currentScreen}`);

  switch (currentScreen) {
    case Screens.CONTACT_FORM:
      FrameComponent = (
        <ContactForm
          changeScreen={changeScreen}
          contactLead={contactLead}
          useAppointmentFlow={useAppointmentFlow}
          onContactFormSubmit={onContactFormSubmit}
          onComplete={onComplete}
          isProcessing={isProcessing}
          shouldValidateOnBlur={shouldValidateOnBlur}
          shouldValidateOnChange={shouldValidateOnChange}
          validators={validators}
          {...rest}
        />
      );
      break;
    case Screens.APPT_LOCATION:
      FrameComponent = (
        <AppointmentLocationForm
          changeScreen={changeScreen}
          selectedLocation={selectedLocation}
          locationSearchForm={locationSearchForm}
          setLocation={setLocation}
          onLocationSearchChange={onLocationSearchChange}
          getLocations={getLocations}
          availableLocations={availableLocations}
          isProcessing={isProcessing}
          {...rest}
        />
      );
      showBackBtn = true;
      break;
    case Screens.APPT_CALENDAR:
      FrameComponent = (
        <AppointmentCalendarForm
          changeScreen={changeScreen}
          bookAppointment={bookAppointment}
          getTimeSlots={getTimeSlots}
          selectedLocation={selectedLocation}
          selectedTime={selectedTime}
          contactLead={contactLead}
          availableTimeSlots={availableTimeSlots}
          setTimeSlot={setTimeSlot}
          onComplete={onComplete}
          isProcessing={isProcessing}
          {...rest}
        />
      );
      showBackBtn = true;
      break;
    case Screens.APPT_SUCCESS:
      FrameComponent = (
        <AppointmentInformation
          selectedLocation={selectedLocation}
          selectedTime={selectedTime}
          success
          {...rest}
        />
      );
      break;
    case Screens.APPT_FAIL:
      FrameComponent = <AppointmentInformation />;
      break;
    default:
      break;
  }

  return (
    <div className={classes}>
      {FrameComponent}
      {isProcessing ? loadingIconRender : null}
      {!isProcessing && showBackBtn ? backButtonRender : null}
    </div>
  );
}

ContactMe.propTypes = {
  contactLead: PropTypes.object,
  contactFields: PropTypes.any,
  contactSchema: PropTypes.object,
  contactFormConfig: PropTypes.object,
  useAppointmentFlow: PropTypes.bool,
  guideType: PropTypes.string,
  guideDelivery: PropTypes.string,
  bookAppointment: PropTypes.any,
  onComplete: PropTypes.any,
  backButton: PropTypes.any,
  loadingIcon: PropTypes.any,
  shouldValidateOnBlur: PropTypes.any,
  shouldValidateOnChange: PropTypes.any,
  isProcessing: PropTypes.any,
  validators: PropTypes.any,
  onContactFormSubmit: PropTypes.any,
  getLocations: PropTypes.any,
  setLocation: PropTypes.any,
  availableLocations: PropTypes.any,
  selectedLocation: PropTypes.any,
  onLocationSearchChange: PropTypes.any,
  locationSearchForm: PropTypes.any,
  getTimeSlots: PropTypes.any,
  setTimeSlot: PropTypes.any,
  availableTimeSlots: PropTypes.any,
  selectedTime: PropTypes.any,
};

export default ContactMe;
